import { useTranslation } from 'react-i18next';

export const Gift = ({ onClose }) => {
    const { t } = useTranslation();
    const days = Number(localStorage.getItem("days")) || 0;


    return (
        <div
            onClick={onClose}
            className="w-full h-full absolute z-[60] bg-bgBlack/30 flex justify-center items-center"
        >
            <div
                onClick={(e) => e.stopPropagation()}
                className="w-[244px] h-[76px] md:w-[347px] md:h-[101px] lg:w-[401px] lg:h-[282px] rounded-[19px] border-[3px] md:border-[4px] border-[#7743BA] bg-[#FFF] flex items-center justify-center"
            >
                <p className="text-[16px] md:text-[20px] lg:text-[24px] text-[#F68C2F] text-center font-fredokaOne">
                    {days === 1
                        ? t("presentPopUpOne")
                        : t("presentPopUp").replace("X", days)}
                </p>
            </div>
        </div>

    );
};
